import { useAppState } from './StateProvider';
export default function Toast() { const { notice } = useAppState(); return notice ? <div className="toast">{notice}</div> : null; }
